"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const PaymentStyled_1 = require("../../pages/paymentBooking/payment/PaymentStyled");
const PaymentSymbolPagSeguro_1 = __importDefault(require("../paymentSymbolPagSeguro/PaymentSymbolPagSeguro"));
const PaymentFormStyle_1 = require("./PaymentFormStyle");
const constants_1 = require("../../assets/constants/constants");
const PagSeguroPromiseResolve_1 = __importDefault(require("../../pages/paymentBooking/payment/PagSeguro/PagSeguroPromiseResolve"));
const api_1 = __importDefault(require("../../services/api"));
const validations_1 = require("../../utils/validations");
const FormSuite_1 = require("../../hooks/FormSuite");
const PixView_1 = __importDefault(require("../pixView/PixView"));
const PagseguroContext_1 = require("../../hooks/PagseguroContext");
const regex_1 = require("../../utils/regex");
const ConfirmValuesContext_1 = require("../../pages/paymentBooking/context/ConfirmValuesContext");
const format_1 = require("../../utils/format");
const PaymentForm = ({ form, needDebitPhoneBR, needPaymentDocCPF }) => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const [displayPayment, setDisplayPayment] = (0, react_1.useState)(constants_1.PAYMENT_TYPE.CREDIT);
    const [currentCreditCardSearched, setCurrentCreditCardSearched] = (0, react_1.useState)('');
    const [showCreditCardError, setShowCreditCardError] = (0, react_1.useState)(false);
    const [getPaymentsMethods, setGetPaymentsMethods] = (0, react_1.useState)({});
    const [isRequiredCreditFields, setIsRequiredCreditFields] = (0, react_1.useState)(true);
    const [cvvFieldState, setCvvFieldState] = (0, react_1.useState)({ status: true });
    const [selectedPaymentType, setSelectedPaymentType] = (0, react_1.useState)(constants_1.PAYMENT_TYPE.CREDIT);
    const { form: formSuite } = (0, FormSuite_1.useFormSuit)();
    const { brandState, handleSetCvvStateAndInstallments, fetchInstallments, installmentsList: { installments }, cleanBrandState, cleanInstallmentsList, setSelectedInstallment, } = (0, PagseguroContext_1.usePagseguro)();
    const getSession = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        yield api_1.default
            .post('/payments/sessions')
            .then(({ data }) => {
            PagSeguroPromiseResolve_1.default.mySetSessionId(data.session.id);
        })
            .catch(err => {
            throw new Error(`${err}`);
        });
    }), []);
    (0, react_1.useEffect)(() => {
        getSession();
    }, [getSession]);
    const getPaymentMethodHandle = (0, react_1.useCallback)(({ amount }) => __awaiter(void 0, void 0, void 0, function* () {
        yield PagSeguroPromiseResolve_1.default.myPaymentMethod(amount)
            .then(response => {
            var _a;
            const { options } = (_a = response.paymentMethods) === null || _a === void 0 ? void 0 : _a.ONLINE_DEBIT;
            setGetPaymentsMethods(options);
        })
            .catch(err => {
            throw new Error(`${err}`);
        });
    }), []);
    const onChangeRadio = (0, react_1.useCallback)((currentRadio) => {
        form.resetFields();
        cleanBrandState();
        cleanInstallmentsList();
        cleanInstallmentFields();
        setCvvFieldState(old => (Object.assign(Object.assign({}, old), { status: true })));
        setShowCreditCardError(false);
        setCurrentCreditCardSearched('');
        setGetPaymentsMethods({});
        form.setFieldsValue({
            paymentType: currentRadio.target.value,
        });
        const isRequired = currentRadio.target.value === constants_1.PAYMENT_TYPE.CREDIT;
        setIsRequiredCreditFields(isRequired);
        const { confirmValues } = confirmValuesContext;
        setSelectedPaymentType(currentRadio.target.value);
        getPaymentMethodHandle({ amount: confirmValues.totalPrice });
        setDisplayPayment(currentRadio.target.value);
    }, [cleanBrandState, cleanInstallmentsList, confirmValuesContext, form, getPaymentMethodHandle]);
    const cleanInstallmentFields = (0, react_1.useCallback)(() => {
        setSelectedInstallment(null);
        form.setFieldsValue({ installment: undefined, installmentObject: undefined });
    }, [form]);
    const handleCreditNumber = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const cardNumber = form.getFieldValue('cardNumber').replace(constants_1.CARD_NUMBER_REGEX, '');
        if (cardNumber.length >= constants_1.CARD_NUMBER_MIN_LENGHT &&
            currentCreditCardSearched.substring(0, constants_1.CARD_NUMBER_MIN_LENGHT) !== cardNumber.substring(0, constants_1.CARD_NUMBER_MIN_LENGHT)) {
            cleanBrandState();
            cleanInstallmentsList();
            setCurrentCreditCardSearched(cardNumber.substring(0, constants_1.CARD_NUMBER_MIN_LENGHT));
            cleanInstallmentFields();
            yield handleSetCvvStateAndInstallments(cardNumber)
                .then((response) => {
                form.setFieldsValue({
                    brand: brandState === null || brandState === void 0 ? void 0 : brandState.brand,
                });
                setShowCreditCardError(false);
                form.validateFields(['cardNumber']);
            })
                .catch((err) => {
                cleanBrandState();
                cleanInstallmentsList();
                cleanInstallmentFields();
                setShowCreditCardError(true);
                form.validateFields(['cardNumber']);
            });
        }
        if (cardNumber.length === constants_1.CARD_NUMBER_MAX_LENGHT) {
            yield fetchInstallments();
            setCvvFieldState(old => (Object.assign(Object.assign({}, old), { status: false })));
        }
        else {
            setCvvFieldState(old => (Object.assign(Object.assign({}, old), { status: true })));
        }
        if (cardNumber.length === 0) {
            cleanBrandState();
            cleanInstallmentFields();
            setShowCreditCardError(false);
            setCurrentCreditCardSearched('');
            form.validateFields(['cardNumber']);
        }
    }), [form, handleSetCvvStateAndInstallments, brandState === null || brandState === void 0 ? void 0 : brandState.brand, cleanBrandState, cleanInstallmentsList, fetchInstallments]);
    (0, react_1.useEffect)(() => {
        if (installments && (brandState === null || brandState === void 0 ? void 0 : brandState.brand) && (installments === null || installments === void 0 ? void 0 : installments[brandState === null || brandState === void 0 ? void 0 : brandState.brand])) {
            const { totalAmount } = installments === null || installments === void 0 ? void 0 : installments[brandState === null || brandState === void 0 ? void 0 : brandState.brand][0];
            if (totalAmount !== (0, format_1.roundTwoDecimals)(confirmValuesContext.confirmValues.totalPrice)) {
                cleanInstallmentFields();
                fetchInstallments();
            }
        }
        else {
            cleanInstallmentFields();
        }
    }, [confirmValuesContext]);
    const handleCvvField = (0, react_1.useCallback)(() => {
        const cvvValue = form.getFieldValue('cvv');
        if (cvvValue) {
            if (cvvValue.length > cvvFieldState.size) {
                form.setFieldsValue({
                    cvv: cvvFieldState.value,
                });
            }
            else {
                setCvvFieldState(old => (Object.assign(Object.assign({}, old), { value: cvvValue })));
            }
        }
    }, [cvvFieldState, form]);
    const handleOnSenderHash = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield PagSeguroPromiseResolve_1.default.myOnSenderHash();
        const formValue = form.getFieldsValue();
        form.setFieldsValue(Object.assign(Object.assign({}, formValue), { senderHash: data }));
    }), [form]);
    const selectHandleInstallment = (0, react_1.useCallback)((installmentNumber) => {
        const installmentValue = installments === null || installments === void 0 ? void 0 : installments[brandState === null || brandState === void 0 ? void 0 : brandState.brand].find(installment => installment.quantity === installmentNumber);
        const formValue = form.getFieldsValue();
        if (installmentValue) {
            setSelectedInstallment(installmentValue);
            form.setFieldsValue(Object.assign(Object.assign({}, formValue), { installmentObject: installmentValue }));
        }
    }, [brandState, form, installments]);
    const handleButtonFill = (0, react_1.useCallback)(() => {
        const formValues = formSuite.getFieldsValue();
        const fieldKey = 0;
        const cardDocumentSetCPF = formValues.suites[fieldKey].documentTypeGuestRequired === 'CPF' &&
            formValues.suites[fieldKey].documentGuestRequired;
        const phone = formValues.suites[fieldKey].ddiRequired === constants_1.CODE_DDI_BRAZIL ? formValues.suites[fieldKey].phoneRequired : '';
        const cleanedPhone = phone.replace(/(\(|\)|-|\s)/g, '');
        let formattedPhone = cleanedPhone;
        if (phone)
            formattedPhone = `(${cleanedPhone.substring(0, 2)}) ${cleanedPhone.substring(2, 7)}-${cleanedPhone.substring(7, cleanedPhone.length)}`;
        form.setFieldsValue({
            cardName: formValues.suites[fieldKey].fullnameRequired.trim(),
            cardDocument: cardDocumentSetCPF,
            birthday: formValues.suites[fieldKey].birthdayRequired,
            phone: formattedPhone,
        });
        handleOnSenderHash();
    }, [form, formSuite, handleOnSenderHash]);
    return (react_1.default.createElement(antd_1.Row, null,
        react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, sm: { span: 12 } },
            react_1.default.createElement(PaymentStyled_1.SubTitle, { level: 4 }, "Dados de Pagamento"),
            react_1.default.createElement("div", { style: { marginBottom: '15px' } },
                react_1.default.createElement(antd_1.Typography.Text, null, "S\u00F3 falta preencher os campos abaixo e garantir sua hospedagem!"))),
        react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, sm: { span: 12 } },
            react_1.default.createElement(PaymentSymbolPagSeguro_1.default, null)),
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 24 },
                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { initialValue: constants_1.PAYMENT_TYPE.CREDIT, name: "paymentType", className: "noselect" },
                        react_1.default.createElement(antd_1.Radio.Group, { style: {
                                width: '100%',
                                marginBottom: '25px',
                                flex: 1,
                            }, onChange: valueChanged => onChangeRadio(valueChanged) },
                            react_1.default.createElement(PaymentFormStyle_1.RadioStyled, { value: constants_1.PAYMENT_TYPE.CREDIT }, "Cart\u00E3o de Cr\u00E9dito"),
                            react_1.default.createElement(PaymentFormStyle_1.RadioStyled, { value: constants_1.PAYMENT_TYPE.DEBIT }, "Cart\u00E3o de D\u00E9bito"),
                            react_1.default.createElement(PaymentFormStyle_1.RadioStyled, { value: constants_1.PAYMENT_TYPE.PIX, onClick: handleOnSenderHash }, "Pix")))),
                react_1.default.createElement(PaymentFormStyle_1.TypeBox, { span: 24, display: displayPayment },
                    react_1.default.createElement(antd_1.Col, { id: "Credit" },
                        react_1.default.createElement(antd_1.Col, { span: 24 },
                            react_1.default.createElement(antd_1.Col, null,
                                react_1.default.createElement(PaymentFormStyle_1.ButtonFill, { onClick: handleButtonFill }, " Preencher com os dados do h\u00F3spede ")),
                            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: 7 },
                                    react_1.default.createElement(antd_1.Row, { wrap: false, align: "bottom" },
                                        react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "cardNumber", label: "N\u00FAmero do Cart\u00E3o", validateTrigger: [], rules: [
                                                {
                                                    required: selectedPaymentType === constants_1.PAYMENT_TYPE.CREDIT,
                                                    message: 'Por favor, insira o número do cartão',
                                                },
                                                () => ({
                                                    validator(rule, value) {
                                                        if (showCreditCardError) {
                                                            return Promise.reject(new Error('Por favor, insira um número válido'));
                                                        }
                                                        return Promise.resolve();
                                                    },
                                                }),
                                            ], required: true, style: {
                                                flex: '1',
                                                marginRight: '5px',
                                            } },
                                            react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { type: "tel", mask: "1111 1111 1111 1111", placeholder: "0000 0000 0000 0000", onChange: handleCreditNumber })),
                                        react_1.default.createElement("div", { style: {
                                                float: 'right',
                                                width: '80px',
                                                height: '40px',
                                                marginBottom: '10px',
                                                marginLeft: 'auto',
                                            } },
                                            react_1.default.createElement("img", { style: {
                                                    width: '68px',
                                                    height: '30px',
                                                    display: (brandState === null || brandState === void 0 ? void 0 : brandState.brand) ? 'flex' : 'none',
                                                }, src: brandState ? `${constants_1.BRAND_IMAGE_LINK_68X30}${brandState === null || brandState === void 0 ? void 0 : brandState.brand}.png` : '//:0', alt: "" })))),
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: 8 },
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "cardName", label: "Nome no Cart\u00E3o", required: true, rules: [
                                            () => ({
                                                validator(rule, value) {
                                                    if (selectedPaymentType !== constants_1.PAYMENT_TYPE.CREDIT) {
                                                        return Promise.resolve();
                                                    }
                                                    const valueTrim = value === null || value === void 0 ? void 0 : value.trim();
                                                    if (!valueTrim) {
                                                        return Promise.reject(new Error('Por favor informe o nome'));
                                                    }
                                                    if (!valueTrim.match(regex_1.REGEX_LETTERS_SPACES)) {
                                                        return Promise.reject(new Error('Por favor remova os caracteres especiais'));
                                                    }
                                                    if (!valueTrim.match(regex_1.REGEX_FULL_NAME)) {
                                                        return Promise.reject(new Error('Por favor informe o nome completo'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ] },
                                        react_1.default.createElement(PaymentFormStyle_1.InputStyled, { onFocus: handleOnSenderHash })),
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { style: { display: 'none' }, name: "senderHash" })),
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: 6 },
                                    react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                                        react_1.default.createElement(antd_1.Col, { span: 11 },
                                            react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "dueDate", label: "Validade", required: true, help: false, rules: [
                                                    {
                                                        required: selectedPaymentType === constants_1.PAYMENT_TYPE.CREDIT,
                                                    },
                                                ] },
                                                react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { type: "tel", mask: "11/1111", placeholder: "MM/AAAA" }))),
                                        react_1.default.createElement(antd_1.Col, { span: 11 },
                                            react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { style: { flex: '1' }, labelCol: { span: 24 }, name: "cvv", label: "CVV", required: true, help: false, rules: [
                                                    {
                                                        required: selectedPaymentType === constants_1.PAYMENT_TYPE.CREDIT,
                                                    },
                                                ] },
                                                react_1.default.createElement(PaymentFormStyle_1.InputStyled, { disabled: cvvFieldState.status, type: "number", min: 0, onChange: handleCvvField })),
                                            react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { name: "brand", style: { display: 'none', width: '0px', height: '0px' } }))))),
                            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: 7 },
                                    react_1.default.createElement(antd_1.Row, null,
                                        react_1.default.createElement(antd_1.Col, { flex: "1" },
                                            react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { style: {
                                                    flex: '1',
                                                }, labelCol: { span: 24 }, name: "cardDocument", label: "CPF", validateTrigger: "onBlur", rules: [
                                                    {
                                                        required: selectedPaymentType === constants_1.PAYMENT_TYPE.CREDIT,
                                                    },
                                                    () => ({
                                                        validator(rule, value) {
                                                            if (!value) {
                                                                return Promise.resolve();
                                                            }
                                                            if (!(0, validations_1.validateCPF)(value)) {
                                                                return Promise.reject(new Error('Insira um CPF válido'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                ] },
                                                react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { type: "tel", mask: "111.111.111-11", placeholder: "000.000.000-00" }))))),
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: 8 },
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, style: { minWidth: '150px' }, name: "birthday", label: "Data de Nascimento", validateTrigger: "onBlur", rules: [
                                            {
                                                required: selectedPaymentType === constants_1.PAYMENT_TYPE.CREDIT,
                                            },
                                            () => ({
                                                validator(rule, value) {
                                                    if (!value) {
                                                        return Promise.resolve();
                                                    }
                                                    const dateFormat = 'DD/MM/YYYY';
                                                    const inputDate = (0, moment_1.default)(value, dateFormat, true);
                                                    if (!(0, moment_1.default)(inputDate).isValid()) {
                                                        return Promise.reject(new Error('Insira uma data válida'));
                                                    }
                                                    const years = (0, moment_1.default)().diff(inputDate, 'years');
                                                    if (years < 18) {
                                                        return Promise.reject(new Error('Não são permitidos pagamentos por pessoas menores de 18 anos'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ] },
                                        react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { type: "tel", mask: "11/11/1111", placeholder: "dd/mm/aaaa" }))),
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: 6 },
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "phone", label: "Telefone", help: false, rules: [
                                            {
                                                required: selectedPaymentType === constants_1.PAYMENT_TYPE.CREDIT,
                                            },
                                        ] },
                                        react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { type: "tel", mask: "(11) 11111-1111", placeholder: "(XX) XXXXX-XXXX" })))),
                            react_1.default.createElement(antd_1.Col, { xs: {
                                    span: 24,
                                    flex: '1',
                                }, sm: {
                                    span: 24,
                                    flex: '1',
                                }, lg: 9 },
                                react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "installment", label: "Parcelas" },
                                    react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { onSelect: (optionValue) => selectHandleInstallment(optionValue), disabled: cvvFieldState.status, size: "large", placeholder: "Selecione a quantidade de parcelas" }, (installments && (brandState === null || brandState === void 0 ? void 0 : brandState.brand) && (installments === null || installments === void 0 ? void 0 : installments[brandState === null || brandState === void 0 ? void 0 : brandState.brand]) != undefined) &&
                                        (installments === null || installments === void 0 ? void 0 : installments[brandState === null || brandState === void 0 ? void 0 : brandState.brand].map(installment => {
                                            return (react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { key: installment.quantity, value: installment.quantity },
                                                `${installment.quantity}x de R$${installment.installmentAmount.toFixed(2)},`,
                                                installment.interestFree && ` Sem Juros,`,
                                                ` Total: R$${installment.totalAmount.toFixed(2)}`));
                                        })))),
                                react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { name: "installmentObject" })))),
                    react_1.default.createElement(antd_1.Col, { id: "Debit" },
                        react_1.default.createElement(antd_1.Col, { span: 24 },
                            react_1.default.createElement(antd_1.Row, null,
                                react_1.default.createElement(antd_1.Col, { xs: {
                                        span: 24,
                                        flex: '1',
                                    }, sm: {
                                        span: 24,
                                        flex: '1',
                                    }, lg: { span: 8 } },
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "bank", label: "Banco" },
                                        react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { size: "large", onFocus: handleOnSenderHash, placeholder: "Selecione um banco" }, getPaymentsMethods &&
                                            Object.entries(getPaymentsMethods).map(value => {
                                                if (value[1].status === 'AVAILABLE') {
                                                    return (react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { key: value[0], value: value[0] },
                                                        react_1.default.createElement("img", { src: constants_1.PAGSEGURO_LINK + value[1].images.SMALL.path, alt: value[1].displayName }),
                                                        react_1.default.createElement("span", { style: { marginLeft: '5px' } }, value[1].displayName)));
                                                }
                                            })))),
                                react_1.default.createElement(antd_1.Col, { xs: { span: 0 }, sm: { span: 0 }, lg: { span: 2 } }),
                                needPaymentDocCPF && (react_1.default.createElement(antd_1.Col, { xs: { span: 24, flex: '1' }, sm: { span: 24, flex: '1' }, lg: { span: 8 } },
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "paymentDocCPF", label: "CPF", rules: [
                                            { required: selectedPaymentType === constants_1.PAYMENT_TYPE.DEBIT },
                                            () => ({
                                                validator(rule, value) {
                                                    if (!value) {
                                                        return Promise.resolve();
                                                    }
                                                    if (!(0, validations_1.validateCPF)(value)) {
                                                        return Promise.reject(new Error('Insira um CPF válido'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ] },
                                        react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { mask: "111.111.111-11", placeholder: "XXX.XXX.XXX-XX" })))),
                                needDebitPhoneBR && (react_1.default.createElement(antd_1.Col, { xs: { span: 24, flex: '1' }, sm: { span: 24, flex: '1' }, lg: { span: 8 } },
                                    react_1.default.createElement(PaymentFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: "phoneBR", label: "Telefone", rules: [
                                            { required: selectedPaymentType === constants_1.PAYMENT_TYPE.DEBIT },
                                            () => ({
                                                validator(rule, value) {
                                                    if (!value) {
                                                        return Promise.resolve();
                                                    }
                                                    if (value.replace(/\D/g, '').length < 10 || value.replace(/\D/g, '').length > 11) {
                                                        return Promise.reject(new Error('Insira um número válido'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ] },
                                        react_1.default.createElement(PaymentFormStyle_1.MaskInputStyled, { mask: "(11) 11111-1111", placeholder: "(XX) XXXXX-XXXX" }))))))),
                    react_1.default.createElement(PixView_1.default, { needPaymentDocCPF: needPaymentDocCPF, needDebitPhoneBR: needDebitPhoneBR, selectedPaymentType: selectedPaymentType }))))));
};
exports.default = PaymentForm;
